import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import Header from "./components/Core/header";
import Sidebar from "./components/Core/sidebar";
import Home from "./components/Core/home";
import AllTasks from "./components/Administration/tasks/all_tasks";
import Task from "./components/Administration/tasks/task";
import AllCompanies from "./components/Data Management/companies/all_companies";
import Company from "./components/Data Management/companies/company";
import Documents from "./components/Data Management/documents/Documents";
import Reporting from "./components/Reporting/Reporting";
import AllTransactions from "./components/Financial/transactions/all_transactions";
import Invoices from "./components/Financial/invoices/Invoices";
import TimeTracking from "./components/Administration/time_tracking/TimeTracking";
import Wishlist from "./components/Financial/wishlist/wishlist";
import DayBuilder from "./components/DayBuilder/DayBuilder";
import NutritionPlanner from "./components/Nutrition/NutritionPlanner";
import WorkoutPlanner from "./components/Workout/WorkoutPlanner";
import Login from "./components/Auth/Login";
import Register from "./components/Auth/Register";
import { Toaster } from "react-hot-toast";

import 'bootstrap/dist/css/bootstrap.min.css';
import "./css/main.css";

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  return user ? children : <Navigate to="/login" />;
};

const App = () => {
  return (
    <Router>
      <AuthProvider>
        <Toaster position="top-right" toastOptions={{ duration: 3000 }} />
        <div className="d-flex flex-column min-vh-100">
          <Header />
          <div className="d-flex flex-grow-1">
            <Sidebar />
            <main className="flex-grow-1 p-3">
              <Routes>
                {/* Public Routes */}
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />

                {/* Protected Routes */}
                <Route path="/" element={
                  <PrivateRoute>
                    <Home />
                  </PrivateRoute>
                } />
                <Route path="/tasks" element={
                  <PrivateRoute>
                    <AllTasks />
                  </PrivateRoute>
                } />
                <Route path="/task/:id" element={
                  <PrivateRoute>
                    <Task />
                  </PrivateRoute>
                } />
                <Route path="/tasks/:id" element={
                  <PrivateRoute>
                    <Task />
                  </PrivateRoute>
                } />
                <Route path="/companies" element={
                  <PrivateRoute>
                    <AllCompanies />
                  </PrivateRoute>
                } />
                <Route path="/company/:id" element={
                  <PrivateRoute>
                    <Company />
                  </PrivateRoute>
                } />
                <Route path="/documents" element={
                  <PrivateRoute>
                    <Documents />
                  </PrivateRoute>
                } />
                <Route path="/templates" element={<Navigate to="/documents" replace />} />
                <Route path="/reporting" element={
                  <PrivateRoute>
                    <Reporting />
                  </PrivateRoute>
                } />
                <Route path="/transactions" element={
                  <PrivateRoute>
                    <AllTransactions />
                  </PrivateRoute>
                } />
                <Route path="/invoices" element={
                  <PrivateRoute>
                    <Invoices />
                  </PrivateRoute>
                } />
                <Route path="/time-tracking" element={
                  <PrivateRoute>
                    <TimeTracking />
                  </PrivateRoute>
                } />
                <Route path="/wishlist" element={
                  <PrivateRoute>
                    <Wishlist />
                  </PrivateRoute>
                } />
                <Route path="/day-builder" element={
                  <PrivateRoute>
                    <DayBuilder />
                  </PrivateRoute>
                } />
                <Route path="/nutrition" element={
                  <PrivateRoute>
                    <NutritionPlanner />
                  </PrivateRoute>
                } />
                <Route path="/workout" element={
                  <PrivateRoute>
                    <WorkoutPlanner />
                  </PrivateRoute>
                } />
              </Routes>
            </main>
          </div>
        </div>
      </AuthProvider>
    </Router>
  );
};

export default App;